/*
* @Author: 曹俊杰
* @Date: 2022-06-08 10:24:17
* @Module: 曝光平台
*/
<template>
  <div class="inspect">
    <div class="left">
      <listMenu v-for="item in menuList" :itemData="item" :key="item.name" pathPrefix="exposure"/>
    </div>
    <div class="right">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>
<script>
import listMenu from '@/components/listMenu/listMenu.vue';
export default {
  components: {
    listMenu
  },
  data() {
    return {
      menuList: [
        {
          title: '曝光台',
          name: 'all',
          icon: 'el-icon-ali-puguangtai'
        },
        {
          title: '我的曝光',
          name: 'mine',
          icon: 'el-icon-ali-wodepuguang',
          authority: []
        }
      ]
    };
  },
}
</script>
<style lang='scss' scoped>
.inspect {
    @include contentStyle2;
}
</style>